import React from 'react';
import { Box, Container, Flex, Heading, Text } from '@chakra-ui/react';
import { useSettlementFilters } from '../hooks/useSettlementFilters';
import { SettlementsFilters } from './settlementsFilters';
import { SettlementsTable } from './SettlementsTable';
import ExportButton from '../../../components/ExportButton';
import {
  SETTLEMENTS_ENDPOINTS,
  SETTLEMENTS_REPORT_FILE_NAME,
  SETTLEMENTS_REPORT_FORMATS,
  SETTLEMENTS_REPORT_LABEL,
} from '../settlements.constants';

export const Settlements = () => {
  const { results, error, nextPage, prevPage, loading, queryParams, reportParams, setDateRange } = useSettlementFilters();

  return (
    <Container
      maxWidth="100%"
      height='100%'
      overflow="hidden"
      display="grid"
      gridTemplateRows="auto 1fr auto"
    >
      <Box>
        <Flex alignItems="center">
          <Heading as="h2" fontSize="xl" marginBottom="xl">Liquidaciones</Heading>
          <ExportButton
            params={reportParams}
            fileName={SETTLEMENTS_REPORT_FILE_NAME}
            path={SETTLEMENTS_ENDPOINTS.report}
            availableFormats={SETTLEMENTS_REPORT_FORMATS}
            label={SETTLEMENTS_REPORT_LABEL} />
        </Flex>
        <Flex paddingX="xl" marginBottom="xl" alignItems="center">
          <Text fontWeight="bold" fontSize="m">Filtros: </Text>
          <SettlementsFilters start={queryParams.start} end={queryParams.end} onDateRangeChange={setDateRange} />
        </Flex>
      </Box>
      <SettlementsTable
        onNextPage={nextPage}
        onPreviousPage={prevPage}
        dataLoading={loading}
        error={error}
        results={results} />
    </Container>
  );
};
